import React, { useCallback, useMemo } from 'react';

const AdsStudoThemeContext = React.createContext({});

// theme is a black box object which could be platform specific
// and is passed down to this context provider, and then
// passed to getStyles functions in withAdsStudioDefaultStyles
export const AdsStudioThemeProvider = ({ theme, componentStyles, children }) => {
  //
  // get styles for a specific components by component name
  // the styles could be a function (theme) => styles, or an object
  const getComponentStyles = useCallback((componentName) => {
    const { components } = theme || {};
    if (componentStyles && componentStyles[componentName]) {
      return componentStyles[componentName];
    }
    if (components && components[componentName]) {
      return components[componentName];
    }
    return undefined;
  }, [componentStyles, theme]);

  const contextValue = useMemo(() => ({
    theme,
    getComponentStyles,
  }), [getComponentStyles, theme]);

  return (
    <AdsStudoThemeContext.Provider value={contextValue}>
      {children}
    </AdsStudoThemeContext.Provider>
  );
};

export const useAdsStudioTheme = () => React.useContext(AdsStudoThemeContext);
